import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import QueryString from 'query-string';

import ClosedReturnRows from './ClosedReturnRows';
import ClosedReturnsFilterPanel from './ClosedReturnsFilterPanel';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import ComponentUtil from '../../utils/componentUtil';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';

import CLOSED_RETURNS_CONTROLLER from '../../controllers/closedReturns';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import {FIELDS as GLOBAL_FILTER_PANEL_FIELDS} from '../filter/GlobalFilterPanel';
import { findCompanyBy } from "../helper/ReactComponentHelper";

import Logger, { LOG_LEVELS } from '../../utils/logger';
import { FeatureFlagEnum, FilingTypeEnum } from '../../utils/enums';
const log = new Logger('CLOSED_RETURNS_PAGE', LOG_LEVELS.DEBUG);

export class Page extends Component {
  constructor(props) {
    super(props);
    this.onFilterPanelSearchClick = this.onFilterPanelSearchClick.bind(this);
  }

  onFilterPanelSearchClick(filterCriteria) {
    log.clearAllDictionaryErrors();
    log.debug('onFilterPanelSearchClick(): filterCriteria: ', filterCriteria);    
    const apiParams = UpdateFilterParams(filterCriteria, this.props.location, this.props.history, this.props.featureFlags?.[FeatureFlagEnum.ENABLE_VIEW_AND_REOPEN_VATBOOK]);

    this.props.onPageLoad(apiParams);
  }

  componentDidMount() {
    log.clearAllDictionaryErrors();

    let parsedQueryParams = QueryString.parse(this.props.location.search);
    let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
    globalFilterSelection = Object.assign({}, globalFilterSelection, { companyId: '670'})

    let filterSelection = Object.assign({}, parsedQueryParams, globalFilterSelection);
    if(!_.isEmpty(filterSelection) && !_.isEmpty(filterSelection.countryCode) ) {
      UpdateFilterParams(filterSelection, this.props.location, this.props.history, this.props.featureFlags?.[FeatureFlagEnum.ENABLE_VIEW_AND_REOPEN_VATBOOK]);
    }

    if (!_.isEmpty(this.props.companies) && filterSelection.companyCode) {
      const company = findCompanyBy('code', filterSelection.companyCode, this.props.companies);
      if (company) {
        let params = ( Object.assign({}, filterSelection, { companyId: company.id }));
        this.props.onPageLoad(params)
      } else {
        log.warn('componentDidMount(): companyCode not found in company list', filterSelection.companyCode);
      }
    }
  }

  componentDidUpdate(prevProps) {
    // TODO this line is stopping the results re-render and why is it needed?
    if((this.props.companies !== prevProps.companies) && !_.isEmpty(this.props.companies)) {
      let parsedQueryParams = QueryString.parse(this.props.location.search) || {};
      let globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll();
      let filterSelection = Object.assign({}, parsedQueryParams, globalFilterValues);
      if(!_.isEmpty(filterSelection)) {
        this.onFilterPanelSearchClick(filterSelection);
      }
    }
  }

  componentWillUnmount() {
    log.debug('componentWillUnmount()');
    log.clearAllDictionaryErrors();
    this.props.onPageUnLoad();
  }

  render() {
     log.debug('render():', this.props);

     let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
     let parsedQueryParams = Object.assign({}, globalFilterSelection, QueryString.parse(this.props.location.search)) ;
     let filterSelection = Object.assign({}, parsedQueryParams);

    let selectedCompanyId = filterSelection.companyId || '';
    let companies = this.props.companies || [];

    let selectedCompanyDetails = companies.filter((company, index) => {
      return (`${selectedCompanyId}` === `${company.id}`);
    });

    return (
      <div className="content-area">          
        <s-container>

          <h1><LanguageStringResolver string='TitleClosedReturns'/></h1>

          <ApplicationMessages messageType="applicationError"/>
          <ApplicationMessages messageType="applicationWarning"/>

          <ClosedReturnsFilterPanel 
            selectedCompanyIds={filterSelection.companyId}
            companySelectionFieldName={'companyId'}
            selectedCompanyDetails={selectedCompanyDetails}
            countryList={this.props.countryList}
            selectedCountryCodes={filterSelection.countryCode}
            countrySelectionFieldName={'countryCode'}
            filingFrequency={filterSelection.filingFrequency}
            startDate={filterSelection.startDate}
            startDateSelectionFieldName={'startDate'}
            endDate={filterSelection.endDate}
            endDateSelectionFieldName={'endDate'}
            filingType={filterSelection.filingType}
            frequencyValue={filterSelection.frequency || ''}
            reportTypeValue={filterSelection.reportType || '0'}
            searchButtonDisabled={_.isEmpty(filterSelection)}
            onSearchClick={this.onFilterPanelSearchClick}
            filterOptions={filterSelection}
          />

          <ClosedReturnRows
            mainCompany={selectedCompanyDetails}
            data={this.props.closedReturns.data}
            onReopenClick={this.props.reopenReturn}
            filterSelection={filterSelection}
          />

        </s-container>
      <div className="clear"></div>
    </div>
    );
  }
}

// Which props do we want to inject, given the global state?
export function mapStateToProps(state) {
  return {
    companies:  (state.companies && state.companies.data) || [],
    closedReturns: (state.closedReturns && state.closedReturns) || [],
    countryList : (state.content && state.content.contentData && state.content.contentData.countryList),
    featureFlags: state.featureFlag && state.featureFlag.data
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    onPageLoad: (params) => {
      log.debug('onPageLoad(): params: ', params);
      dispatch(CLOSED_RETURNS_CONTROLLER.getClosedReturns(params));
    },
    onPageUnLoad: () => {
      log.debug('onPageUnload');
      dispatch(CLOSED_RETURNS_CONTROLLER.doUnload());
    },
    getClosedReturns: (params) => {
      log.debug('getClosedReturns: params: ', params);
      dispatch(CLOSED_RETURNS_CONTROLLER.getClosedReturns(params));
    },
    reopenReturn: (params, filterCriteria) => {
      // After reopen refresh the table so get returns again so pass a callback
      // which is run after the reopen completes
      log.debug('reopenReturn: params: %s, filterCriteria: %s', params, filterCriteria);
      dispatch(CLOSED_RETURNS_CONTROLLER.reopenReturn(params, () => {
        dispatch(CLOSED_RETURNS_CONTROLLER.getClosedReturns(filterCriteria));
      }))
    }
  }
}

export function UpdateFilterParams(filterCriteria, location, history, isViewAndReopenVatbookEnabled) {
  let options = {};
  if (!isViewAndReopenVatbookEnabled && filterCriteria.filingType === FilingTypeEnum.VATBOOKS) {
    options = { removal: ['filingType'] };
    delete filterCriteria['filingType'];
  };
  
  const apiParam = Object.assign({}, filterCriteria);
  [GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID].forEach(key => delete filterCriteria[key]);
  ComponentUtil.updateUrlParams(location, history, filterCriteria, options);
  return apiParam;
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(Page);
